import type { ReactNode } from 'react';
import { createContext, useContext, useState } from 'react';

interface AlgoliaEventContextProps {
  indexName: string;
  isSearched: boolean;
  queryID: string;
  setIndexName: (value: string) => void;
  setIsSearched: (value: boolean) => void;
  setQueryID: (value: string) => void;
}

export const AlgoliaEventContext = createContext<
  AlgoliaEventContextProps | undefined
>(undefined);

export const AlgoliaEventProvider = ({ children }: { children: ReactNode }) => {
  const [isSearched, setIsSearched] = useState(false);
  const [queryID, setQueryID] = useState<string>('');
  const [indexName, setIndexName] = useState<string>('');

  return (
    <AlgoliaEventContext.Provider
      value={{
        isSearched,
        setIsSearched,
        queryID,
        setQueryID,
        indexName,
        setIndexName,
      }}
    >
      {children}
    </AlgoliaEventContext.Provider>
  );
};

export const useAlgoliaEvent = () => {
  const context = useContext(AlgoliaEventContext);
  if (!context) {
    throw new Error(
      'useAlgoliaEvent must be used within a AlgoliaEventProvider',
    );
  }
  return context;
};
